(function () {
  'use strict';

  if (window.PGCartOnwardBrandV37) return;
  window.PGCartOnwardBrandV37 = true;

  var observer = null;
  var timer = null;

  function normalise(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function visible(element) {
    if (!element || !element.getBoundingClientRect) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      parseFloat(style.opacity || '1') > 0.01 &&
      rect.width > 1 &&
      rect.height > 1;
  }

  function isControl(element) {
    return Boolean(element && element.closest('button, a, input, [role="button"]'));
  }

  function findCheckoutHeadingText(scope) {
    if (!scope || !document.createTreeWalker) return null;

    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (normalise(node.nodeValue) !== 'checkout+') return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || !visible(parent) || isControl(parent)) return NodeFilter.FILTER_REJECT;
        if (parent.closest('.pg-onward-brand-v37')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var matches = [];
    var node;
    while ((node = walker.nextNode())) {
      var rect = node.parentElement.getBoundingClientRect();
      matches.push({ node: node, area: rect.width * rect.height });
    }

    matches.sort(function (a, b) { return a.area - b.area; });
    return matches.length ? matches[0].node : null;
  }

  function createBrand() {
    var brand = document.createElement('span');
    brand.className = 'pg-onward-brand-v37';
    brand.setAttribute('aria-label', 'by Onward');
    brand.innerHTML = '' +
      '<span class="pg-onward-brand-v37__by">by</span>' +
      '<svg class="pg-onward-brand-v37__mark" viewBox="0 0 18 18" aria-hidden="true" focusable="false">' +
        '<path d="M2.5 12.8 7.7 11.4 6.5 16.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M6.4 8.3 11.6 6.9 10.4 12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<path d="M10.3 3.9 15.5 2.5 14.3 7.6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '<span class="pg-onward-brand-v37__word">Onward</span>';
    return brand;
  }

  function applyScope(scope) {
    if (!scope || scope.querySelector('.pg-onward-brand-v37')) return;

    var textNode = findCheckoutHeadingText(scope);
    if (!textNode || !textNode.parentElement) return;

    textNode.parentElement.classList.add('pg-onward-heading-v37');
    textNode.parentElement.insertBefore(createBrand(), textNode.nextSibling);
  }

  function apply() {
    applyScope(document.querySelector('.cart_content'));
    applyScope(document.querySelector('#pg-cart .pg-cart__summary'));
  }

  function schedule(delay) {
    window.clearTimeout(timer);
    timer = window.setTimeout(apply, delay == null ? 0 : delay);
  }

  function mutationTouchesCart(mutation) {
    var target = mutation.target && mutation.target.nodeType === 1
      ? mutation.target
      : mutation.target && mutation.target.parentElement;

    if (target && target.closest && target.closest('.cart_content, #pg-cart')) return true;

    return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
      return node instanceof Element && (
        node.matches('.cart_content, #pg-cart') ||
        Boolean(node.querySelector && node.querySelector('.cart_content, #pg-cart'))
      );
    });
  }

  function init() {
    apply();

    document.addEventListener('cart:refresh', function () { schedule(20); });
    document.addEventListener('pg:cart-form-patched', function () { schedule(20); });
    document.addEventListener('shopify:cart:lines-update', function () { schedule(40); });
    document.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('.cart_content, #pg-cart')) {
        schedule(80);
      }
    }, true);

    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function () { schedule(20); });
    }

    if (window.MutationObserver && document.body) {
      observer = new MutationObserver(function (mutations) {
        if (mutations.some(mutationTouchesCart)) schedule(20);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    [120, 400, 900, 1800, 3500, 7000].forEach(function (delay) {
      window.setTimeout(apply, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
